import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { HomeDelivery, HomeDeliveryCreate, HomeDeliveryFilter } from '../data/homeDelivery';

export function createHomeDeliveryService(client: AxiosInstance) {
  return createCrudService<HomeDelivery, HomeDeliveryCreate, HomeDeliveryFilter>(
    client,
    '/restaurant/HomeDelivery',
    'id',
  );
}

export type HomeDeliveryService = CrudService<HomeDelivery, HomeDeliveryCreate, HomeDeliveryFilter>;
